module.exports = __webpack_public_path__ + "static/media/hall-P3.b03a18a4.svg";